import React, { useEffect } from "react";
import yup from "yup";
import { useLocalStore } from "mobx-react";
import { FormStore } from "@modules/formx";
import { Form } from "@modules/formx-react";
import locale from "@bonliva-crm/locale";
import { Text } from "@components/formx";
import { StatusMetaProps } from "./StatusMetaProps";

export type MetaData = {
  comment?: string;
};

export function StatusMeta(props: StatusMetaProps<MetaData>) {
  const { store, disabled } = props;

  const localStore = useLocalStore(() => {
    return {
      form: new FormStore<MetaData>({
        initialValues: props.store.metadata,
        onSetValue: ({ store: formStore }) => {
          if (formStore.valid) {
            props.store.setStatusMetaData(formStore.values);
          }

          props.store.setStatusCanSubmit(formStore.canSubmit);
        }
      })
    };
  });

  useEffect(() => {
    const schema = yup.object<MetaData>({
      comment: store.isCommentRequired
        ? yup.string().required(locale.Comment)
        : yup.string()
    });

    localStore.form.setSchema(schema);
  }, [store.isCommentRequired]);

  useEffect(() => props.store.setStatusCanSubmit(false), []);

  return (
    <Form store={localStore.form} allowUpdates>
      {store.withComment && (
        <Text
          name="comment"
          label={store.commentLabel}
          TextFieldProps={{ fullWidth: true }}
          disabled={disabled ?? false}
        />
      )}
    </Form>
  );
}
